export default "__VITE_ASSET__D4TC0369__"